import api from "../config";

export const authAPI = {
  login: async (credentials) => {
    try {
      const { identifier, password } = credentials;

      if (!identifier || !password) {
        throw new Error("Identifiant et mot de passe requis");
      }

      const { data } = await api.post("/auth/login", { identifier, password });
      localStorage.setItem("token", data.accessToken);
      return data;
    } catch (error) {
      console.error("❌ Erreur de connexion :", error.message);
      throw error;
    }
  },

  logout: async () => {
    await api.post("/auth/logout");
    localStorage.removeItem("token");
  },

  refreshToken: async () => {
    const { data } = await api.post("/auth/refresh-token");
    localStorage.setItem("token", data.accessToken);
    return data;
  },
};
